import { componentSizes } from '@/theme/componentSizes';
import { r } from '@/theme/tokens';

const uploadTokenActionIconSize = componentSizes.auth.inputHeight - 2;
const uploadTokenActionGroupBackgroundColor = 'var(--surface-page)';

export const uploadTokenActionGroupSx = {
  backgroundColor: uploadTokenActionGroupBackgroundColor,
  border: '1px solid',
  borderColor: 'divider',
  borderRadius: r('sm'),
  overflow: 'hidden',
  '& .MuiButton-root': {
    color: 'text.primary',
    borderColor: 'divider',
    minWidth: 0,
    backgroundColor: uploadTokenActionGroupBackgroundColor,
    borderRadius: '0 !important',
  },
  '& .MuiButton-root:hover': {
    backgroundColor: 'action.hover',
  },
  '& .MuiButtonGroup-grouped': {
    width: uploadTokenActionIconSize,
    minWidth: uploadTokenActionIconSize,
    maxWidth: uploadTokenActionIconSize,
    flex: `0 0 ${uploadTokenActionIconSize}px`,
    padding: 0,
    borderRadius: '0 !important',
  },
  '& .MuiButtonGroup-grouped:not(:last-of-type)': {
    borderRight: '1px solid',
    borderColor: 'divider',
  },
  '& .MuiButton-root.Mui-disabled': {
    color: 'text.disabled',
  },
} as const;

export const uploadTokenActionButtonSx = {
  width: uploadTokenActionIconSize,
  height: uploadTokenActionIconSize,
  minWidth: uploadTokenActionIconSize,
  minHeight: uploadTokenActionIconSize,
  padding: 0,
  borderRadius: 0,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  lineHeight: 1,
  '& .MuiSvgIcon-root': {
    fontSize: 17,
    display: 'block',
  },
} as const;

export const projectWebhookActionRotateIconSx = {
  fontSize: 21,
} as const;

export const projectWebhookActionPlayIconSx = {
  fontSize: 22,
} as const;

export const projectWebhookActionDeleteIconSx = {
  fontSize: 20,
} as const;

export const uploadTokenActionButtonPrimarySx = {
  '&&': {
    backgroundColor: 'primary.main',
    color: 'primary.contrastText',
  },
  '&&:hover': {
    backgroundColor: 'primary.dark',
  },
} as const;
